'use client'

import MyGames from 'pageContainers/MyGames/Games'
import { useAppSelector } from 'src/store/hooks'
import { playedTableGamesSelector, playedGamesLayoutSelector } from 'store/modules/playedGames/selectors'

import t from '../../../utils/getTranslationClient'

export default function TableGames() {
  const games = useAppSelector(playedTableGamesSelector)
  const layout = useAppSelector(playedGamesLayoutSelector)

  return <MyGames games={games} gameType='table' title={t('my_table_games')} dataTestId='game-tiles-container' layout={layout} />
}
